import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import { Advt } from './components/Advt/Advt';
import Message from './components/Message/Message';

import defaultBackground from './assets/images/bg.png';

function App() {
  const { currentState, currentMessage, stateCarousel } = useBroadcast();
  const { duration, authorFontSize, sizeQR, bg, bgColor } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg]);

  return (
    <div
      className="app-wrapper"
      style={{
        background,
      }}
    >
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <div className="message-wrapper">
            <motion.div
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              transition={{ duration: 1 }}
              exit={{
                x: '-100%',
                transition: {
                  delay: 1,
                  duration: 0.5,
                },
              }}
              className="bgMotion"
            />

            <Advt />

            {stateCarousel && currentMessage && (
              <motion.div
                style={{ paddingTop: `${Number(sizeQR) + 19.625}rem` }}
                className="motionBlock"
                key={`msg-${currentState}`}
                exit={{
                  y: '-100vh',
                  scale: 0.5,
                  opacity: 0,
                  transition: { duration: 1 },
                }}
              >
                <Message
                  authorFontSize={authorFontSize}
                  currentMessage={currentMessage}
                  message={currentMessage?.message}
                  duration={duration}
                />
              </motion.div>
            )}
          </div>
        )}
      </AnimatePresence>

      <div id="img-loader" />
    </div>
  );
}

export default App;
